<template>
  <v-col class="pa-0">
    <v-row
      class="cb-row-tabs d-lg-none"
    >
      <v-col>
        <v-divider class="mb-2" />
        <v-row>
          <v-col
            v-if="selectedTab.id != 'explorer'"
            class="pa-0 text-center"
            cols="2"

          >
            <v-btn
              class="ma-0"
              icon
              @click="changeTab(storeTabs[0])"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-col>
          <v-col
            :cols="selectedTab.id != 'explorer' ? 10: 12"
            class="pa-0"
          >
            <v-select
              v-model="selectedTab"
              :items="storeTabs"
              class="pa-0"
              full-width
              hide-details
              item-text="name"
              item-value="id"
              return-object
              @change="changeTab"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="cb-explorer-tabs d-none d-lg-block">
      <v-tabs
        v-model="selectedTab.id"
        height="26"
        hide-slider
      >
        <v-tab
          v-for="s in storeTabs"
          :key="s.id"
          :href="'#'+s.id"
          active-class="cb-tab-active"
          class="cb-tab "
          @click="changeTab(s)"
          @click.middle="closeTab(s)"
        >
          <div
            v-if="s.id != 'explorer'"
            :title="s.id"
            class="px-2"
          >
            <v-row justify="space-between">
          <span
            class="text-truncate my-auto "
            style="max-width: 254px;display: inline-block;direction: rtl"
          >{{ s.name }}</span>
              <v-tooltip bottom>
                <template
                  v-slot:activator="{ on }"
                >
                  <v-icon
                    class="my-auto"
                    @click="closeTab(s)"
                    v-on="on"
                  >clear
                  </v-icon>
                </template>
                <span>Cerrar pestaña</span>
              </v-tooltip>
            </v-row>
          </div>
          <div
            v-else
            title="Resultado de la búsqueda"
          >
            <v-icon>{{ $icons.I_TAB_LIST }}</v-icon>
          </div>
        </v-tab>
      </v-tabs>
    </v-row>
    <v-row
      class="ma-0"
      dense
    >
      <v-col
        class="pa-0 cb-view-fixed-height"
        cols="12"
      >
        <v-tabs-items
          v-model="selectedTab.id"
          class="cb-view-tabs"
          style="padding: 0"
        >
          <v-tab-item
            id="explorer"
            :transition="false"
          >
            <slot name="explorer-tab" />
          </v-tab-item>

          <v-tab-item
            v-for="tab in storeTabs.filter(st => st.id != 'explorer')"
            :id="tab.id"
            :key="tab.id"
            :transition="false"
          >
            <slot
              v-if="selectedTab.id == tab.id"
              :slot_id="tab.id"
              name="details-tab"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  import helpers from '@/plugins/helpers'

  export default {
    name: 'ExplorerTabs',
    props: {
      model: String,
      storageData: Object,
      hideTabs: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      activeTab: {
        get() {
          let active = this.storeTabs.find(st => st.active)
          if (helpers.nullOrEmpty(active)) {
            this.changeTab({ id: 'explorer' })
          }
          return active
        },
        set(id) {
          this.changeTab(id)
        }
      },
      storeTabs: {
        get() {
          return this.$store.state[this.storageData.namespace][this.storageData.state]
        },
        set(val) {
          this.$store.dispatch(this.storageData.namespace + '/' + this.storageData.action, val)
        }
      },
      selectedTab: {
        get() {
          return this.activeTab
        },
        set(val) {
          this.$emit('changeTab', val)
        }
      }
    },
    created() {

      let id = this.$route.query.id
      if (!helpers.nullOrEmpty(id)) {
        this.changeTab({
          id: id,
          name: this.$route.query.name
        })
      } else {
        this.changeTab({ id: 'explorer' })
      }
    },
    methods: {
      changeTab(newTab) {
        let newTabs = []
        let valid = true
        this.storeTabs.forEach(nt => {
          let tab = Object.assign({}, nt)
          tab.active = tab.id == newTab.id ? true : false
          newTabs.push(tab)
        })
        if (newTabs.find(st => st.id == newTab.id) == null) {

          if (newTabs.length - 1 >= 6) {
            valid = false
            helpers.setAlertMessage(1, 'No puedes abrir más de 6 pestañas')
          } else {
            newTabs.push({
              id: newTab.id,
              name: newTab.name,
              active: true
            })

          }
        }
        if (valid) {
          this.setQuery(newTab)
          this.storeTabs = newTabs
        }
      },
      setQuery(newTab) {
        if (newTab.id == 'explorer') {
          if (this.$route.query.id != null) {
            this.$router.push({ path: this.$route.path, query: null })
          }
        } else {
          if (this.$route.query.id != newTab.id) {
            this.$router.push({ path: this.$route.path, query: newTab })
          }
        }
      },
      closeTab(tab) {
        let newTabs = this.storeTabs.filter(it => it.id !== tab.id)
        newTabs[0].active = true
        this.storeTabs = newTabs

        this.setQuery(newTabs[0])
      },
      closeAllTabs() {
        let newTabs = this.storeTabs.filter(it => it.id == 'explorer')
        newTabs[0].active = true
        this.storeTabs = newTabs

        this.setQuery(newTabs[0])
      }

    }
  }
</script>

<style lang="scss">
  @import "src/assets/styles/resources/colors";

  .cb-row-tabs {
    border-bottom: 1px solid $color_app_primary;
    background-color: $color_app_clear;
  }

  .cb-row-tabs .cb-explorer-tab {

    border-bottom: 1px solid $color_app_contrast_low !important;


  }

  .cb-tab {
    min-width: 40px;
    padding: 0;
  }

  .cb-tab-active {
    font-weight: bold;
    background-color: rgba($color_app_primary, 0.2);
  }

  .cb-explorer-tabs {
    border-bottom: thin solid $color_app_contrast_medium_low !important;
  }

  .cb-tab button:hover {
    font-weight: bold;
    color: $color_app_error !important;
  }
</style>
